import { createContext } from "react";

const GraficasContext = createContext();

export default GraficasContext;
